import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import Header from '@components/common/Header/Header';

import useTranslation from '@hooks/useTranslation';

import { useTemplatesListQuery } from '@services/useTemplatesListQuery';

import FilterPanel from './components/FilterPanel/FilterPanel';
import Footer from './components/Footer/Footer';
import TableEquipments from './components/TableEquipments/TableEquipments';
import { useManageTemplateFilterActions } from './store/useManageTemplateFilterStore';
import style from './style.module.scss';

const ManageTemplate = () => {
  const equipmentTableContainerRef = useRef(null);

  const { trackPageView } = useMatomo();
  const { templateId } = useParams();
  const { t } = useTranslation();

  const { setManageTemplateFilterInitialState } = useManageTemplateFilterActions();

  const { data: templatesListData } = useTemplatesListQuery();

  useEffect(() => {
    trackPageView({});
  }, []);

  useEffect(() => {
    return () => {
      setManageTemplateFilterInitialState();
    };
  }, []);

  const template = templatesListData?.find((item) => templateId && +item.id === +templateId);

  return (
    <div className={style.manageTemplate}>
      <Header
        title={`${t('Manage Template')}: ${template?.name}`}
        isSecondaryPage={true}
        extraInfo={
          <div className={style.messageBlock}>
            {t(
              'On this page, you can add equipment to your template. Select the equipment you wish to include and ensure to save your changes.',
            )}
          </div>
        }
      />

      <div className={style.manageTemplateBody}>
        <FilterPanel />
        <TableEquipments equipmentTableContainerRef={equipmentTableContainerRef} />
      </div>
      <Footer template={template} equipmentTableContainerRef={equipmentTableContainerRef} />
    </div>
  );
};

export default ManageTemplate;
